import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logoutUser } from '../../../../actions/auth';
import { openErrorToast } from '../../../../reducers/uiLogic';
import {
  CompanyDetailsHead,
  CompanyDetailsWrapper,
  CompanyLogoWrapper,
  CompanyNameWrapper,
} from './styles';
import { DEFAULT_COMPANY_LOGO } from '../../../../constants/images';

const CompanyDetails = ({ companyProfile }) => {
  const logoImgStyle = {
    height: '50px',
    width: '50px',
  };
  const companyLogo =
    companyProfile.company_logo && companyProfile.company_logo !== ''
      ? companyProfile.company_logo
      : DEFAULT_COMPANY_LOGO;
  return (
    <CompanyDetailsWrapper>
      <CompanyDetailsHead>
        <CompanyLogoWrapper>
          {' '}
          <img src={companyLogo} alt='Logo' style={logoImgStyle} />
          {' '}
        </CompanyLogoWrapper>
        <CompanyNameWrapper>
          {companyProfile.company_short_name}
        </CompanyNameWrapper>
      </CompanyDetailsHead>
    </CompanyDetailsWrapper>
  );
};

CompanyDetails.propTypes = {
  companyProfile: PropTypes.objectOf(PropTypes.any),
};

CompanyDetails.defaultProps = {
  companyProfile: {},
};

const mapDispatchToProps = dispatch => ({
  logUserOut: () => dispatch(logoutUser()),
  showErrorToast: () => dispatch(openErrorToast()),
});

export default connect(
  null,
  mapDispatchToProps,
)(CompanyDetails);
